import type { HostSlotActivity, HostSlotStatus } from './hostSlotPort.js';

/**
 * What a placement is doing while its `ready` is pending, readable and
 * observable by the slot. A listener that throws is contained, so one broken
 * observer cannot keep the others from hearing a change or stall the placement.
 */
export class ActivityStatus implements HostSlotStatus {
  private activity: HostSlotActivity;
  private readonly listeners = new Set<() => void>();

  constructor(initial: HostSlotActivity = 'loading') {
    this.activity = initial;
  }

  read(): HostSlotActivity {
    return this.activity;
  }

  subscribe(onChange: () => void): () => void {
    this.listeners.add(onChange);
    return () => {
      this.listeners.delete(onChange);
    };
  }

  set(next: HostSlotActivity): void {
    if (next === this.activity) {
      return;
    }
    this.activity = next;
    for (const listener of Array.from(this.listeners)) {
      try {
        listener();
      } catch {
        // One failing observer must not reach the others or the placement.
      }
    }
  }
}
